module.exports = __webpack_public_path__ + "img/LSO.5ac09078.gif";